import { FC } from "react";

import { OnboardingIntroContentOnDark } from "@/blocks/OnboardingIntroContentOnDark";
import { OnboardingScreenType } from "@/domain/onboarding";

import introBackground from "./assets/intro-background.jpg";
import { PhotoCardStepFrame } from "./PhotoCardStepFrame";

const IMAGE_POSITION = { left: "55%", top: "0%" } as const;

export const PhotoCardIntroStep: FC<OnboardingScreenType> = layout => (
  <PhotoCardStepFrame
    {...layout}
    image={introBackground}
    imagePosition={IMAGE_POSITION}>
    <OnboardingIntroContentOnDark />
  </PhotoCardStepFrame>
);
